//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all audit records.
 * @param tableName (optional) 
 * @param patientId (optional) 
 * @param startDate (optional) 
 * @param endDate (optional) 
 * @param userId (optional) 
 * @param subtenantIds (optional) 
 * @param changedProperties (optional) if TableName != null
 * @param filterCondition (optional) if TableName != null
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getAuditRecords(tableName?: string | null | undefined, patientId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, userId?: string | null | undefined, subtenantIds?: number[] | null | undefined, changedProperties?: string[] | undefined, filterCondition?: { [key: string]: string; } | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfAuditRecordDto> {
    let url_ = getBaseUrl() + "/api/audit-records?";
    if (tableName !== undefined && tableName !== null)
        url_ += "TableName=" + encodeURIComponent("" + tableName) + "&";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (startDate !== undefined && startDate !== null)
        url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
    if (endDate !== undefined && endDate !== null)
        url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
    if (userId !== undefined && userId !== null)
        url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    if (subtenantIds !== undefined && subtenantIds !== null)
        subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
    if (changedProperties === null)
        throw new Error("The parameter 'changedProperties' cannot be null.");
    else if (changedProperties !== undefined)
        changedProperties && changedProperties.forEach(item => { url_ += "ChangedProperties=" + encodeURIComponent("" + item) + "&"; });
    if (filterCondition === null)
        throw new Error("The parameter 'filterCondition' cannot be null.");
    else if (filterCondition !== undefined)
        filterCondition && Object.keys(filterCondition).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + filterCondition[key]) + "&"; });
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAuditRecords,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetAuditRecords?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAuditRecords(_response);
    });
}

function processGetAuditRecords(response: AxiosResponse): Promise<Types.PageableListDtoOfAuditRecordDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfAuditRecordDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfAuditRecordDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfAuditRecordDto>(null as any);
}

/**
 * Gets all properties for a table.
 * @param tableName The table name.
 */
export function getTableProperties(tableName: string, config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/audit-records/{tableName}/properties";
    if (tableName === undefined || tableName === null)
      throw new Error("The parameter 'tableName' must be defined.");
    url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetTableProperties,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetTableProperties?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetTableProperties(_response);
    });
}

function processGetTableProperties(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

/**
 * Gets table names.
 */
export function getTableNames(config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/audit-records/table-names";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetTableNames,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetTableNames?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetTableNames(_response);
    });
}

function processGetTableNames(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

/**
 * Gets properties for sorting.
 */
export function getSortFields(config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/audit-records/sort-fields";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSortFields,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSortFields?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSortFields(_response);
    });
}

function processGetSortFields(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}
let _requestConfigGetAuditRecords: Partial<AxiosRequestConfig> | null;
export function getGetAuditRecordsRequestConfig() {
  return _requestConfigGetAuditRecords;
}
export function setGetAuditRecordsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAuditRecords = value;
}
export function patchGetAuditRecordsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAuditRecords = patch(_requestConfigGetAuditRecords ?? {});
}

let _requestConfigGetTableProperties: Partial<AxiosRequestConfig> | null;
export function getGetTablePropertiesRequestConfig() {
  return _requestConfigGetTableProperties;
}
export function setGetTablePropertiesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetTableProperties = value;
}
export function patchGetTablePropertiesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetTableProperties = patch(_requestConfigGetTableProperties ?? {});
}

let _requestConfigGetTableNames: Partial<AxiosRequestConfig> | null;
export function getGetTableNamesRequestConfig() {
  return _requestConfigGetTableNames;
}
export function setGetTableNamesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetTableNames = value;
}
export function patchGetTableNamesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetTableNames = patch(_requestConfigGetTableNames ?? {});
}

let _requestConfigGetSortFields: Partial<AxiosRequestConfig> | null;
export function getGetSortFieldsRequestConfig() {
  return _requestConfigGetSortFields;
}
export function setGetSortFieldsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSortFields = value;
}
export function patchGetSortFieldsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSortFields = patch(_requestConfigGetSortFields ?? {});
}